
import {
    Color,
    Euler,
    EventDispatcher,
    Raycaster,
    TOUCH,
    Spherical,
    Vector2,
    Vector3,
    MathUtils
} from "../../node_modules/three/build/three.module.js";

let IndoorControls = function ( camera, domElement ) {

    if ( domElement === undefined ) console.error( 'Please use "renderer.domElement".' );

    this.camera = camera;
    this.domElement = domElement;

    // Set to false to disable this control
	this.enabled = true;
   
    this.speedRotating = 0.001;
   
    this.rotateAnimate = true;
   
    this.rotateDamping = 0.1;
    
    this.rotatePrecision = 0.1;

   
    this.speedMoving = 10;
   
    this.moveAnimate = true;
   
    this.moveTime = 1.6;

   
    this.speedKeyMoving = 40;

   
    this.ground = null;

    this.isMovementActive = false;

    this.rotateSpeed = 250.0;

    // Touch fingers
   // this.touches = { ONE: TOUCH.ROTATE, TWO: TOUCH.DOLLY_PAN };

    let scope = this;

    let euler = new Euler( 0, 0, 0, 'YXZ' );

    let PI_2 = Math.PI / 2;

    let vec = new Vector3();

   
    let prevTime = performance.now();

  
    let canRotate = false;
  
    let isRotating = false;
  
    let movement = new Vector2();
   
    let prevMovement = new Vector2();
  
    let mouse = new Vector2();
  
    let raycaster = new Raycaster();
  
    let intersects = [];

 
    let canMove = false;
   
    let isMoving = false;
  
    let target = new Vector3();
  
    let targetDir = new Vector3();
  
    let targetDis = 0;
   
    let targetTime = 0;
   
    let targetAcc = 0;
   
    let targetSpeed = 0;

    // current position in spherical coordinates
	let spherical = new Spherical();
	let sphericalDelta = new Spherical();

	let rotateStart = new Vector2();
	let rotateEnd = new Vector2();
	let rotateDelta = new Vector2();

    
    let moveForward = false;
    let moveBackward = false;
    let moveLeft = false;
    let moveRight = false;
    let moveUp = false;
    let moveDown = false;
   
    let moveDir = new Vector3();

    
    let moveEvent = { type: 'move' };
    
    let moveClickEvent = { type: 'moveclick' };
    
    let rotateDownEvent = { type: 'rotatedown' };
    
    let rotateUpEvent = { type: 'rotateup' };

    function onContextMenu( event ) {

        event.preventDefault();

    }

    function onMouseDown( event ) {

        if ( scope.enabled === false ) return;

       // event.preventDefault();

        scope.domElement.focus();

        canRotate = true;
        canMove = true;
    }

    function onTouchStart( event ) {

        if ( scope.enabled === false ) return;

		event.preventDefault(); // prevent scrolling

		switch ( event.touches.length ) {

			case 1:
                scope.domElement.focus();

                canRotate = true;
                canMove = true;
                rotateStart.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

                if ( scope.ground ) {

           
                    mouse.x = ( event.touches[ 0 ].pageX / window.innerWidth ) * 2 - 1;
                    mouse.y = - ( event.touches[ 0 ].pageY / window.innerHeight ) * 2 + 1;
        
                   
                    raycaster.setFromCamera( mouse, scope.camera );
        
                   
                    intersects = raycaster.intersectObject( scope.ground, true );
        
                    
                    if ( intersects.length > 0 ) {
        
                        moveEvent[ 'intersect' ] = intersects[ 0 ];
                        scope.dispatchEvent( moveEvent );
                    }
                   
                }
            	break;
			case 2:
                console.log("Null");
				break;

			default:
				break;

		}

	}

    function onMouseMove( event ) {

        if ( scope.enabled === false ) return;

        if ( canRotate === true ) {

            canMove = false;

            movement.x += event.movementX || event.mozMovementX || event.webkitMovementX || 0;
            movement.y += event.movementY || event.mozMovementY || event.webkitMovementY || 0;

            isRotating = true;
        }

       
        if ( scope.ground ) {

           
            mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
            mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

           
            raycaster.setFromCamera( mouse, scope.camera );

           
            intersects = raycaster.intersectObject( scope.ground, true );

            
            if ( intersects.length > 0 ) {

                moveEvent[ 'intersect' ] = intersects[ 0 ];
                scope.dispatchEvent( moveEvent );
            }
           
        }
    }

    function onTouchMove( event ) {

        if ( scope.enabled === false ) return;

		event.preventDefault(); // prevent scrolling
		// event.stopPropagation();

        if ( canRotate === true ) {
            canMove = false;
           
            handleTouchMoveRotate(event);
            isRotating = true;
        }

	}

    function rotateLeft( angle ) {

		movement.x += angle;

	}

	function rotateUp( angle ) {

		movement.y += angle;

	}

    function handleTouchMoveRotate( event ) {

		if ( event.touches.length == 1 ) {

			rotateEnd.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

		} else {

			let x = 0.5 * ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX );
			let y = 0.5 * ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY );

			rotateEnd.set( x, y );

		}

		rotateDelta.subVectors( rotateEnd, rotateStart ).multiplyScalar( scope.rotateSpeed );

		let element = scope.domElement;

		rotateLeft( 2 * Math.PI * rotateDelta.x / element.clientHeight ); // yes, height

		rotateUp( 2 * Math.PI * rotateDelta.y / element.clientHeight );

		rotateStart.copy( rotateEnd );

	}

    function onTouchEnd( event ) {

        if ( scope.enabled === false ) return;

		handleTouchEnd( event );
	}

    function handleTouchEnd( event ) {

        event.preventDefault();

        canRotate = false;

       
        if ( canMove === true && isMoving === false ) {

            if ( intersects.length === 0 ) return;

            target.copy( intersects[ 0 ].point );
            target.y = scope.camera.position.y;

            if ( target.equals( scope.camera.position ) ) return;

            targetDir.subVectors( target, scope.camera.position ).normalize();
            targetDis = target.distanceToSquared( scope.camera.position );

            if ( scope.moveAnimate === true ) {

                
                targetAcc = 4 * Math.sqrt( targetDis ) / Math.pow( scope.moveTime, 2 );

            }
            scope.isMovementActive = true;
            isMoving = true;
        }


	}

    function onMouseUp( event ) {

        if ( scope.enabled === false ) return;

        //event.preventDefault();

        canRotate = false;

       
        if ( canMove === true && isMoving === false ) {

            if ( intersects.length === 0 ) return;

            target.copy( intersects[ 0 ].point );
            target.y = scope.camera.position.y;

            if ( target.equals( scope.camera.position ) ) return;

            targetDir.subVectors( target, scope.camera.position ).normalize();
            targetDis = target.distanceToSquared( scope.camera.position );

            if ( scope.moveAnimate === true ) {

                
                targetAcc = 4 * Math.sqrt( targetDis ) / Math.pow( scope.moveTime, 2 );

            }
            scope.isMovementActive = true;
            isMoving = true;
        }

    }

    // listeners

	function onPointerDown( event ) {

        if ( scope.enabled === false ) return;

		switch ( event.pointerType ) {

			case 'mouse':
			case 'pen':
				onMouseDown( event );
				break;

			// TODO touch

		}

	}

	function onPointerMove( event ) {

        if ( scope.enabled === false ) return;

		switch ( event.pointerType ) {

			case 'mouse':
			case 'pen':
				onMouseMove( event );
				break;

			// TODO touch

		}

	}

	function onPointerUp( event ) {

        if ( scope.enabled === false ) return;

		switch ( event.pointerType ) {

			case 'mouse':
			case 'pen':
				onMouseUp( event );
				break;

			// TODO touch

		}

	}

    function onKeyDown( event ) {

        if ( scope.enabled === false ) return;

        switch ( event.keyCode ) {

            case 38:
            case 87: // w
                moveForward = true;
                break;

            case 37: // left
            case 65: // a
                moveLeft = true;
                break;

            case 40:
            case 83: // s
                moveBackward = true;
                break;

            case 39: // right
            case 68: // d
                moveRight = true;
                break;

            // case 38: // up
            //     moveUp = true;
            //     break;

            // case 40: // down
            //     moveDown = true;
            //     break;

        }

    }

    function onKeyUp( event ) {

        if ( scope.enabled === false ) return;

        switch ( event.keyCode ) {

            case 38:
            case 87: // w
                moveForward = false;
                break;

            case 37: // left
            case 65: // a
                moveLeft = false;
                break;

            case 40:
            case 83: // s
                moveBackward = false;
                break;

            case 39: // right
            case 68: // d
                moveRight = false;
                break;

            // case 38: // up
            //     moveUp = false;
            //     break;

            // case 40: // down
            //     moveDown = false;
            //     break;

        }

    }

    //
    // public methods
    //

    this.connect = function () {

        scope.domElement.addEventListener( 'contextmenu', onContextMenu, false );

        scope.domElement.addEventListener( 'pointerdown', onPointerDown, false );
        scope.domElement.addEventListener( 'touchstart', onTouchStart, false );
        scope.domElement.addEventListener( 'mousedown', onMouseDown, false );
        scope.domElement.addEventListener( 'mousemove', onMouseMove, false );
        scope.domElement.addEventListener( 'touchmove', onTouchMove, false );
        scope.domElement.addEventListener( 'touchend', onTouchEnd, false );
        scope.domElement.addEventListener( 'mouseup', onMouseUp, false );

        scope.domElement.ownerDocument.addEventListener( 'pointermove', onPointerMove, false );
        scope.domElement.ownerDocument.addEventListener( 'pointerup', onPointerUp, false );

        scope.domElement.addEventListener( 'keydown', onKeyDown, false );
        scope.domElement.addEventListener( 'keyup', onKeyUp, false );

       
        if ( scope.domElement.tabIndex === - 1 ) scope.domElement.tabIndex = 0;

    };

    this.disconnect = function () {

        scope.domElement.removeEventListener( 'contextmenu', onContextMenu, false );

        scope.domElement.removeEventListener( 'pointerdown', onPointerDown, false );
        scope.domElement.removeEventListener( 'touchstart', onTouchStart, false );
        scope.domElement.removeEventListener( 'mousedown', onMouseDown, false );
        scope.domElement.removeEventListener( 'mousemove', onMouseMove, false );
        scope.domElement.removeEventListener( 'touchmove', onTouchMove, false );
        scope.domElement.removeEventListener( 'touchend', onTouchEnd, false );
        scope.domElement.removeEventListener( 'mouseup', onMouseUp, false );

        scope.domElement.ownerDocument.removeEventListener( 'pointermove', onPointerMove, false );
        scope.domElement.ownerDocument.removeEventListener( 'pointerup', onPointerUp, false );

        scope.domElement.removeEventListener( 'keydown', onKeyDown, false );
        scope.domElement.removeEventListener( 'keyup', onKeyUp, false );

    };

    this.dispose = function () {

        this.disconnect();

    };

    this.moveForward = function ( distance ) {

        // move forward parallel to the xz-plane
        // assumes camera.up is y-up

        vec.setFromMatrixColumn( scope.camera.matrix, 0 );

        vec.crossVectors( scope.camera.up, vec );

        scope.camera.position.addScaledVector( vec, distance );

    };

    this.moveRight = function ( distance ) {

        vec.setFromMatrixColumn( scope.camera.matrix, 0 );

        scope.camera.position.addScaledVector( vec, distance );
    };

    this.moveUp = function ( distance ) {

        vec.set( 0, 1, 0 );

        scope.camera.position.addScaledVector( vec, distance );

    };

    this.update = function () {

        let time = performance.now();
        let interval = ( time - prevTime ) / 1000;

        
        if ( isRotating === true ) {

            if ( movement.equals( new Vector2() ) ) movement.copy( prevMovement );

            euler.setFromQuaternion( scope.camera.quaternion );

            euler.y += movement.x * scope.speedRotating;
            euler.x += movement.y * scope.speedRotating;

            
            euler.x = Math.max( - PI_2, Math.min( PI_2, euler.x ) );

            scope.camera.quaternion.setFromEuler( euler );

            if ( scope.rotateAnimate === true ) {

               
                movement.x = movement.x * ( 1 - scope.rotateDamping );
                movement.y = movement.y * ( 1 - scope.rotateDamping );

            } else {

                movement.copy( new Vector2() );

            }

            if ( Math.abs( movement.x ) <= scope.rotatePrecision && Math.abs( movement.y ) <= scope.rotatePrecision ) isRotating = false;

            prevMovement.copy( movement );
            movement.copy( new Vector2() );

        }

        
        if ( isMoving === true && target.equals( scope.camera.position ) === false ) {

            let cameraLater = scope.camera.position.clone();

           
            if ( scope.moveAnimate === true ) {

                targetTime += interval;

                if ( targetTime < scope.moveTime / 2 ) {

                    targetSpeed += targetAcc * interval;
                    cameraLater.addScaledVector( targetDir, targetSpeed * interval + 0.5 * targetAcc * interval * interval );

                } else {

                    targetSpeed -= targetAcc * interval;
                    cameraLater.addScaledVector( targetDir, targetSpeed * interval - 0.5 * targetAcc * interval * interval );

                }

                // console.log( targetSpeed + ',' + target.distanceTo( scope.camera.position ) );

            } else {

                cameraLater.addScaledVector( targetDir, scope.speedMoving * interval );

            }

           
            let targetDisLater = target.distanceToSquared( cameraLater );

            if ( targetDisLater >= targetDis ) {

                target.copy( scope.camera.position );
                targetDis = 0;
                targetTime = 0;
                targetSpeed = 0;

                isMoving = false;
                scope.isMovementActive = false;

            } else {

                scope.camera.position.copy( cameraLater );
                targetDis = targetDisLater;

            }

        }

        
        if ( isMoving === false ) {

           
            moveDir.z = Number( moveForward ) - Number( moveBackward );
            moveDir.x = Number( moveRight ) - Number( moveLeft );
            moveDir.y = Number( moveUp ) - Number( moveDown );
            moveDir.normalize();


            scope.moveForward( moveDir.z * scope.speedKeyMoving * interval );
            scope.moveRight( moveDir.x * scope.speedKeyMoving * interval );
            scope.moveUp( moveDir.y * scope.speedKeyMoving * interval );

        }

        prevTime = time;

    };

    this.connect();

};

IndoorControls.prototype = Object.create( EventDispatcher.prototype );
IndoorControls.prototype.constructor = IndoorControls;

export { IndoorControls };